import {
  CONTENT_NOTIFICATION_DELIVERY_TYPES,
  ContentNotificationDeliveryTypeEnum,
} from 'constants-notifications';

type NotificationWithDeliveryTypes = {
  deliveryTypes?: ContentNotificationDeliveryTypeEnum[] | null;
};

export type NotificationDeliveryTypeSummary =
  | { kind: 'single'; deliveryType: ContentNotificationDeliveryTypeEnum }
  | {
      kind: 'multiple';
      count: number;
      deliveryTypes: ContentNotificationDeliveryTypeEnum[];
    };

export function getNotificationDeliveryTypeSummary(
  notifications: NotificationWithDeliveryTypes[] | null | undefined
): NotificationDeliveryTypeSummary | null {
  const present = new Set(
    (notifications ?? []).flatMap(
      notification => notification.deliveryTypes ?? []
    )
  );

  const deliveryTypes = CONTENT_NOTIFICATION_DELIVERY_TYPES.filter(
    deliveryType => present.has(deliveryType)
  );

  if (deliveryTypes.length === 0) {
    return null;
  }

  if (deliveryTypes.length === 1) {
    return { kind: 'single', deliveryType: deliveryTypes[0] };
  }

  return {
    kind: 'multiple',
    count: deliveryTypes.length,
    deliveryTypes,
  };
}
